import type { MessageKey } from "./ru"

export const kaMessages = {
  "common.loading": "იტვირთება...",
  "common.error": "შეცდომა",
  "common.back": "უკან",
  "common.next": "შემდეგ",
  "common.search": "ძიება",
  "auth.loginErrorTitle": "შესვლის შეცდომა",
  "auth.openViaTelegram": "გახსენით აპი Telegram-ის მეშვეობით",
  "auth.telegramRequired": "აპი უნდა გაიხსნას Telegram-ის მეშვეობით",
  "auth.authorizationError": "ავტორიზაციის შეცდომა",
  "device.rotatePortrait": "მოაბრუნეთ მოწყობილობა ვერტიკალურ რეჟიმში",
  "country.brazil": "ბრაზილია",
  "country.vietnam": "ვიეტნამი",
  "country.egypt": "ეგვიპტე",
  "country.india": "ინდოეთი",
  "country.indonesia": "ინდონეზია",
  "country.iran": "ირანი",
  "country.spain": "ესპანეთი",
  "country.italy": "იტალია",
  "country.kazakhstan": "ყაზახეთი",
  "country.colombia": "კოლუმბია",
  "country.malaysia": "მალაიზია",
  "country.mexico": "მექსიკა",
  "country.nigeria": "ნიგერია",
  "country.pakistan": "პაკისტანი",
  "country.russia": "რუსეთი",
  "country.usa": "აშშ",
  "country.turkey": "თურქეთი",
  "country.uzbekistan": "უზბეკეთი",
  "country.ukraine": "უკრაინა",
  "country.philippines": "ფილიპინები",
  "countrySelection.chooseCountry": "აირჩიეთ ქვეყანა",
  "countrySelection.openAria": "ქვეყნის არჩევა",
  "languageSelection.chooseLanguage": "აირჩიეთ ენა",
  "commercial.direction.autotrade": "ავტობაზარი",
  "commercial.direction.insurance": "დაზღვევა",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "გზაზე დახმარება",
  "commercial.searchLabel": "BeepApp ძიება",
  "commercial.cityPlaceholder": "შეიყვანეთ ქალაქი",
  "commercial.emptyTitle": "დღეს შეთავაზებები არ არის",
  "commercial.emptyLine1": "თქვენს ქალაქში ჯერ არ არიან BeepApp-ის აქტიური პარტნიორები",
  "commercial.emptyLine2": "ჩვენ უკვე ვმუშაობთ მათ მოძიებასა და დაკავშირებაზე",
  "commercial.emptyLine3": "ახალი შეთავაზებები აქ ავტომატურად გამოჩნდება",
  "commercial.helperLine1": "შეიყვანეთ თქვენი ქალაქი, რომ ნახოთ",
  "commercial.helperLine2": "ხელმისაწვდომი შეთავაზებები",
  "commercial.partnerPrompt": "გსურთ გახდეთ BeepApp-ის პარტნიორი?",
  "commercial.apply": "განაცხადის შეტანა",
  "main.admin": "ადმინი",
  "main.garage": "გარაჟი",
  "main.signalSent": "სიგნალი გაიგზავნა",
  "main.partnerInviteUnavailable": "პარტნიორული მოწვევა მიუწვდომელია",
  "main.enterPlate": "შეიყვანეთ სანომრე ნიშანი",
  "main.searchError": "ძიების შეცდომა",
  "main.signalSendError": "სიგნალის გაგზავნა ვერ მოხერხდა",
  "main.shareCardPrefix": "ნომრის ბარათი",
  "main.shareLinkError": "ბმულის მომზადება ვერ მოხერხდა",
  "main.searchByPlateAria": "ძიება სანომრე ნიშნით",
  "main.russianPlateAria": "რუსული სანომრე ნიშანი",
  "main.plateAria": "სანომრე ნიშანი",
  "main.findPlateAria": "ნომრის მოძებნა",
  "main.loadingVehicle": "ნომრის ბარათი იტვირთება…",
  "main.leaveSignal": "სიგნალის გაგზავნა",
  "main.share": "გაზიარება",
  "signalSelection.chooseType": "აირჩიეთ სიგნალის ტიპი",
  "signalSelection.category.attention": "პირადი",
  "signalSelection.category.road": "საგზაო",
  "signalSelection.category.urgent": "სასწრაფო",
  "signalSelection.chooseSignal": "აირჩიეთ სიგნალი",
  "signalSelection.suggestOwn": "შესთავაზეთ თქვენი ვარიანტი",
  "signalConfirmation.title": "დაადასტურეთ სიგნალი",
  "signalConfirmation.plateHeading": "შეამოწმეთ სანომრე ნიშანი",
  "signalConfirmation.signalHeading": "შეამოწმეთ არჩეული სიგნალი",
  "signalConfirmation.replyTitle": "Telegram-ში პასუხის დაშვება",
  "signalConfirmation.replyBody": "ჩართეთ, რათა ნომრის მფლობელმა შეძლოს\nTelegram-ში მოგწეროთ. პასუხი შესაძლებელია მხოლოდ თუ\nგაქვთ @username. პასუხის გაცემის გადაწყვეტილება რჩება\nნომრის მფლობელთან.",
  "signalConfirmation.consentText": "ვადასტურებ, რომ ეს სიგნალი ასახავს\nრეალურ სიტუაციას და არ არის სპამი\nან ცრუ შეტყობინება.",
  "signalConfirmation.warning": "გაგზავნის შემდეგ სიგნალის\nშეცვლა შეუძლებელია",
  "signalConfirmation.sending": "იგზავნება…",
  "signalConfirmation.send": "გაგზავნა",
  "partner.loadingAria": "იტვირთება",
  "partner.title": "პარტნიორული პროგრამა",
  "partner.offerLine1": "მიიღეთ 30% ყველა გადახდიდან უვადოდ",
  "partner.offerLine2": "თქვენ მიერ BeepApp-ში მოწვეული მომხმარებლებისგან",
  "partner.offerLine3": "Telegram-ის პარტნიორული პროგრამის მეშვეობით",
  "partner.connectUnavailable": "დაკავშირება ხელმისაწვდომი გახდება Telegram Affiliate Program-ის გამართვის შემდეგ.",
  "partner.connectTelegram": "Telegram-ში დაკავშირება",
  "partner.qrAria": "პარტნიორული ბმულის QR კოდი",
  "partner.download": "ჩამოტვირთვა",
  "partner.promoHeading": "შექმენით პირადი პრომოკოდი",
  "partner.promoHelperLine1": "პრომოკოდი ააქტიურებს გამოწერის დამატებით ერთ წელს",
  "partner.promoHelperLine2": "და ეხმარება მომხმარებლების მოზიდვას",
  "partner.promoAria": "პრომოკოდი",
  "partner.affiliateHeading": "თქვენი პარტნიორული ბმული",
  "partner.affiliateHelper": "შეინახეთ ბმული პირადი QR კოდის შესაქმნელად",
  "partner.affiliateAria": "პარტნიორული ბმული",
  "partner.qrNoteLine1": "QR კოდი შეგიძლიათ განათავსოთ თქვენს ავტომობილზე,",
  "partner.qrNoteLine2": "სოციალურ ქსელებში და სარეკლამო მასალებში",
  "partner.save": "შენახვა",
  "partner.reset": "განულება",
  "partner.resetConfirm": "განულდეს შენახული პარტნიორული ბმული? პრომოკოდი თქვენ დაგრჩებათ.",
  "partner.promoFormatError": "პრომოკოდი უნდა შეიცავდეს 4-დან 15 სიმბოლომდე.",
  "partner.affiliateHostError": "დაშვებულია მხოლოდ t.me ან telegram.me ბმულები.",
  "partner.affiliatePathError": "ბმული არ შეიცავს Telegram-ის მისამართს.",
  "partner.affiliateFormatError": "არასწორი პარტნიორული ბმული.",
  "partner.loadError": "ჩატვირთვის შეცდომა",
  "partner.checkInputError": "შეამოწმეთ შეყვანილი ინფორმაცია",
  "garageActivation.promoInvalid": "პრომოკოდი არასწორია",
  "garageActivation.plateOccupied": "ეს სანომრე ნიშანი უკვე მიბმულია",
  "garageActivation.activateError": "გარაჟის გააქტიურება ვერ მოხერხდა",
  "garageEntry.loadJournalError": "ჟურნალის ჩატვირთვა ვერ მოხერხდა",
  "garageEntry.loadStatusesError": "სტატუსების ჩატვირთვა ვერ მოხერხდა",
  "garageEntry.activationSuccess": "გარაჟი წარმატებით გააქტიურდა",
  "garageEntry.plateAttached": "ნომერი მიბმულია",
  "garageEntry.attachError": "ნომრის მიბმა ვერ მოხერხდა",
  "garageEntry.activationNote": "გააქტიურეთ თქვენი გარაჟი",
  "garageSheet.activationTitle": "გარაჟის გააქტიურება",
  "garageSheet.plateHelper": "შეიყვანეთ ავტომობილის სანომრე ნიშანი",
  "garageSheet.promoHelper": "გაქვთ პრომოკოდი?",
  "garageSheet.cleanBonusLine1": "გააქტიურების შემდეგ გექნებათ 1 საათი",
  "garageSheet.cleanBonusLine2": "უფასო „სუფთა სტარტისთვის“",
  "garageSheet.activationFor": "გააქტიურება",
  "garageSheet.cost": "ღირებულება",
  "garageSheet.ownerConsentLine1": "ვადასტურებ, რომ ვარ მფლობელი",
  "garageSheet.ownerConsentLine2": "მითითებული სანომრე ნიშნით",
  "garageSheet.ownerConsentLine3": "ავტომობილის.",
  "garageSheet.processing": "მუშავდება...",
  "garageSheet.attach": "მიბმა",
  "garageSheet.pay": "გადახდა",
  "garageLifecycle.cleanTitle": "სუფთა სტარტი",
  "garageLifecycle.deactivateTitle": "გარაჟის დეაქტივაცია",
  "garageLifecycle.cleanWarningLine1": "ნომრის ისტორია წაიშლება",
  "garageLifecycle.cleanWarningLine2": "აღდგენის შესაძლებლობის გარეშე!",
  "garageLifecycle.deactivateWarningLine1": "დეაქტივაციის შემდეგ აქტიურ",
  "garageLifecycle.deactivateWarningLine2": "გარაჟის ფუნქციებზე წვდომა შეწყდება",
  "garageLifecycle.willBeDeleted": "წაიშლება",
  "garageLifecycle.cleanRemovedLine1": "• ყველა ჩანაწერი ჟურნალიდან",
  "garageLifecycle.cleanRemovedLine2": "• მიღებული სიგნალების ისტორია",
  "garageLifecycle.cleanRemovedLine3": "• სიგნალების საჯარო მრიცხველები",
  "garageLifecycle.cleanRemovedLine4": "  ნომრის ბარათზე",
  "garageLifecycle.willRemain": "დარჩება",
  "garageLifecycle.cleanPreservedLine1": "• ნომრის მიბმა გარაჟთან",
  "garageLifecycle.cleanPreservedLine2": "• გააქტიურების დარჩენილი ვადა",
  "garageLifecycle.cleanPreservedLine3": "• არჩეული ნომრის სტატუსი",
  "garageLifecycle.cleanPreservedLine4": "• ნომრის ბარათის ნახვების საერთო რაოდენობა",
  "garageLifecycle.freeFirstHour": "უფასოა პირველი საათის განმავლობაში",
  "garageLifecycle.willBecomeUnavailable": "გახდება მიუწვდომელი",
  "garageLifecycle.deactivateRemovedLine1": "• ჟურნალი",
  "garageLifecycle.deactivateRemovedLine2": "• ნომრის სტატუსის არჩევა და გამოყენება",
  "garageLifecycle.deactivateRemovedLine3": "• ავტომატურად დატოვებთ AutoClan-ს",
  "garageLifecycle.deactivateRemovedLine4": "• ავტობაზარი",
  "garageLifecycle.deactivateRemovedLine5": "• დაზღვევა",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• გზაზე დახმარება",
  "garageLifecycle.deactivateRemovedLine8": "• სანომრე ნიშანი მოიხსნება გარაჟიდან",
  "garageLifecycle.willRemainAvailable": "დარჩება ხელმისაწვდომი",
  "garageLifecycle.deactivatePreservedLine1": "• თანამგზავრი",
  "garageLifecycle.deactivatePreservedLine2": "• დისპეტჩერი",
  "garageLifecycle.deactivatePreservedLine3": "• სანომრე ნიშნის ძიება და ნახვა",
  "garageLifecycle.deactivatePreservedLine4": "  ავტომობილის საჯარო ბარათი",
  "garageLifecycle.deactivatePreservedLine5": "• ხელახლა გააქტიურების შესაძლებლობა",
  "garageLifecycle.deactivatePreservedLine6": "  გარაჟი ნებისმიერ დროს",
  "garageLifecycle.cleanConsentLine1": "ვადასტურებ თანხმობას წაიშალოს",
  "garageLifecycle.cleanConsentLine2": "ამ ნომრის სრული ისტორია",
  "garageLifecycle.cleanConsentLine3": "აღდგენის შესაძლებლობის გარეშე.",
  "garageLifecycle.deactivateConsentLine1": "ვადასტურებ დეაქტივაციას და",
  "garageLifecycle.deactivateConsentLine2": "ყველა აქტიურ გარაჟის ფუნქციაზე",
  "garageLifecycle.deactivateConsentLine3": "წვდომის შეწყვეტას.",
  "garageLifecycle.clean": "გასუფთავება",
  "garageLifecycle.deactivate": "დეაქტივაცია",
} satisfies Record<MessageKey, string>
